module.exports = __webpack_public_path__ + "img/substitution-up-symbol.eeb054c9.svg";